import { ChangeDetectorRef, Component, EventEmitter, Input, Output, Renderer2 } from '@angular/core';
import { DsTooltipPosition } from '@levelaccess/design-system';
import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';

export interface IToggleCellConfig extends ICellConfig {
  isToggleOn?: boolean;
  isDisabled?: boolean;
  ariaLabelledby?: string;
  tooltip?: string;
}

@Component({
  selector: 'table-cell-toggle',
  styleUrls: ['../base-cell/base-cell.component.scss', './toggle-cell.component.scss'],
  standalone: false,
  template: `
    <button
      type="button"
      role="checkbox"
      name="toggle-cell"
      [disabled]="config.isDisabled"
      [attr.aria-checked]="config.isToggleOn"
      [attr.aria-labelledby]="config.ariaLabelledby"
      class="switch-button switch round"
      [ds-tooltip]="config.tooltip ? (config.tooltip | translate) : null"
      [tooltipPlacement]="DsTooltipPosition.top"
      (click)="onValueChanged()"
      #ref
    >
      <span class="slider round" [attr.aria-hidden]="true"></span>
    </button>
  `,
})
export class ToggleCellComponent extends BaseCellComponent {
  public readonly DsTooltipPosition: typeof DsTooltipPosition = DsTooltipPosition;

  @Input() public config: IToggleCellConfig;
  @Output() public valueChange: EventEmitter<IToggleCellConfig> = new EventEmitter<IToggleCellConfig>();

  constructor(
    renderer: Renderer2,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    super(renderer);
  }

  public onValueChanged(): void {
    this.config = {
      ...this.config,
      isToggleOn: !this.config.isToggleOn,
    };
    this.valueChange.emit(this.config);
    this.changeDetectorRef.detectChanges();
  }
}
